import AppCourseButton from '@js/components/search/AppCourseButton.vue'
import AppCalendarSearch from '@js/components/search/AppCalendarSearch.vue'
import AppWebinarsSearch from '@js/components/search/AppWebinarsSearch.vue'
import AppSiteSearchResults from '@js/components/search/AppSiteSearchResults.vue'

const searchComponents = [
  AppCourseButton,
  AppCalendarSearch,
  AppWebinarsSearch,
  AppSiteSearchResults,
]

export default searchComponents
